/**
 * @internalapi
 */
export class PostMessagePairingRequest {
    type = 'postmessage-pairing-request';
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, icon, appUrl) {
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
    }
}
/**
 * @internalapi
 */
export class ExtendedPostMessagePairingRequest extends PostMessagePairingRequest {
    senderId;
    constructor(id, name, publicKey, version, senderId, icon, appUrl) {
        super(id, name, publicKey, version, icon, appUrl);
        this.senderId = senderId;
    }
}
//# sourceMappingURL=PostMessagePairingRequest.js.map